var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Editar",
    transform: "translate(1314.383 -8061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-edit-2",
    "data-name": "Icon feather-edit-2",
    d: "M10.8,3.688a1.471,1.471,0,1,1,2.08,2.08l-7.02,7.02L3,13.567l.78-2.86Z",
    transform: "translate(-1309.871 8065.175)",
    fill: "none",
    stroke: "#d5007f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24800",
    "data-name": "Trazado 24800",
    d: "M12.5,25A12.5,12.5,0,1,1,25,12.5,12.514,12.514,0,0,1,12.5,25m0-23.809A11.309,11.309,0,1,0,23.808,12.5,11.321,11.321,0,0,0,12.5,1.191",
    transform: "translate(-1314.383 8061)",
    fill: "#d5007f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditar);
export default __webpack_public_path__ + "static/media/Editar.e27a3f0573dd0af25af1c23a0f1bc02f.svg";
export { ForwardRef as ReactComponent };